import { useContext } from 'react'

import { PageContext } from '@pages/EntityCreateOrEdit'

import { PayloadCreateAction } from '@types'

import { AddActionDialog } from '../AddActionDialog'

export const AddViewActionDialog = () => {
  const {
    createAction,
    currentRow,
    currentEntity,
    editAction,
    isActionLoading,
    onSetModalProperty,
    entityCode,
    bindingValuesAction,
    actionTable,
    onCloseModal,
    showDialog,
    modalType,
    mainTable: { rows },
    objectCode,
  } = useContext(PageContext)

  const handleEditAction = (action: PayloadCreateAction) => {
    return editAction?.(action).unwrap()
  }

  const handleCreateAction = (action: PayloadCreateAction) => {
    return createAction?.(action).unwrap()
  }

  return (
    <AddActionDialog
      actionTable={actionTable}
      bindingValuesAction={bindingValuesAction}
      columns={rows}
      createAction={handleCreateAction}
      currentEntity={currentEntity}
      currentRow={currentRow}
      editAction={handleEditAction}
      entityCode={entityCode}
      isActionLoading={isActionLoading}
      modalType={modalType}
      objectCode={objectCode}
      showDialog={showDialog}
      onCloseModal={onCloseModal}
      onSetModalProperty={onSetModalProperty}
    />
  )
}
